export const version = 'kunde-v1.20.0-SNAPSHOT-72309f62c123ae8e155181ee92f7e5c185fefb55';